(function () {
  if (window.__IG_ID7_FS_LOADED__) return;
  window.__IG_ID7_FS_LOADED__ = true;

  var CLASS_NAME = "ig-id7-a";
  var VARIANT_THRESHOLD_EUR = 99;
  var ELIGIBLE_COUNTRIES = {
    BE: true,
    NL: true
  };
  var NL_BE_LINE =
    /NL\s*\/\s*BE|Netherlands\s*(?:&amp;|&)\s*Belgium|Netherlands\s+and\s+Belgium|Nederland.*Belgi|Belgi.*Nederland/i;
  var applying = false;
  var scheduled = null;

  function isActive() {
    return document.documentElement.classList.contains(CLASS_NAME);
  }

  function getCountry(bar) {
    var fromBar = bar && bar.getAttribute("data-fs-country");
    if (fromBar) return fromBar.toUpperCase();
    if (window.Shopify && Shopify.country) return String(Shopify.country).toUpperCase();
    return "";
  }

  function isEligibleMarket(bar) {
    return !!ELIGIBLE_COUNTRIES[getCountry(bar)];
  }

  function formatMoney(cents, currency) {
    var amount = Math.round(cents / 100);
    if (currency === "EUR") return "€" + amount;
    if (currency === "GBP") return "£" + amount;
    if (currency === "USD") return "$" + amount;
    return amount + " " + currency;
  }

  function replaceNlBeThreshold(html) {
    return html
      .replace(
        /(Netherlands\s*(?:&amp;|&)\s*Belgium[^\n<]*?(?:free from|Gratis vanaf|Kostenlos ab)\s*)€\s*119/gi,
        "$1€99"
      )
      .replace(
        /(NL\s*\/\s*BE[^\n<]*?(?:Free from|Gratis vanaf|Kostenlos ab)\s*)€\s*119/gi,
        "$1€99"
      )
      .replace(/Free from €119/g, "Free from €99")
      .replace(/free from €119/g, "free from €99")
      .replace(/Gratis vanaf €119/g, "Gratis vanaf €99")
      .replace(/Kostenlos ab €119/g, "Kostenlos ab €99");
  }

  function scheduleApply() {
    if (applying || scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      applyAll();
    });
  }

  function applyPageCopy() {
    if (!isActive() || !isEligibleMarket()) return;

    var candidates = document.querySelectorAll(
      "li, p, .accordian-wrap.small .accordian-content-inr, .accordian-wrap.small .rte"
    );
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.getAttribute("data-ig-id7-fs") === "1") continue;
      if (el.closest("[data-free-shipping-bar]")) continue;

      var html = el.innerHTML;
      if (!html || html.indexOf("119") === -1) continue;
      if (!NL_BE_LINE.test(html) && !NL_BE_LINE.test(el.textContent || "")) continue;

      var next = replaceNlBeThreshold(html);
      if (next === html) continue;

      applying = true;
      try {
        el.innerHTML = next;
        el.setAttribute("data-ig-id7-fs", "1");
      } finally {
        applying = false;
      }
    }
  }

  function applyBar() {
    if (!isActive() || applying) return;

    var bar = document.querySelector("[data-free-shipping-bar]");
    if (!bar || !isEligibleMarket(bar)) return;

    var currency = (bar.getAttribute("data-fs-currency") || "EUR").toUpperCase();
    if (currency !== "EUR") return;

    var thresholdCents = VARIANT_THRESHOLD_EUR * 100;
    var totalCents = parseInt(bar.getAttribute("data-fs-total"), 10);
    if (isNaN(totalCents)) totalCents = 0;

    var remaining = thresholdCents - totalCents;
    var pct = Math.min(100, Math.max(0, (totalCents / thresholdCents) * 100));
    var pctStr = pct + "%";
    var fill = bar.querySelector(".cart-progress-bar__fill");
    var message = bar.querySelector(".cart-progress-bar__message");
    var remainingTpl = bar.getAttribute("data-fs-message") || "";
    var successTpl = bar.getAttribute("data-fs-success") || "";
    var nextText = "";
    var nextSuccess = false;

    if (remaining > 0 && remainingTpl) {
      nextText = remainingTpl.replace("[amount]", formatMoney(remaining, currency));
    } else if (successTpl) {
      nextText = successTpl;
      nextSuccess = true;
    }

    var thresholdStr = String(thresholdCents);
    var needsThreshold = bar.getAttribute("data-fs-threshold") !== thresholdStr;
    var needsFill = fill && fill.style.width !== pctStr;
    var needsText = message && nextText && message.textContent !== nextText;
    var needsSuccess =
      message &&
      nextText &&
      message.classList.contains("cart-progress-bar__message--success") !== nextSuccess;

    if (!needsThreshold && !needsFill && !needsText && !needsSuccess) return;

    applying = true;
    try {
      if (needsThreshold) bar.setAttribute("data-fs-threshold", thresholdStr);
      if (needsFill) fill.style.width = pctStr;
      if (message && nextText) {
        if (needsSuccess) {
          message.classList.toggle("cart-progress-bar__message--success", nextSuccess);
        }
        if (needsText) message.textContent = nextText;
      }
    } finally {
      applying = false;
    }
  }

  function applyAll() {
    applyBar();
    applyPageCopy();
  }

  function boot() {
    applyAll();

    var root = document.querySelector(".cart-sidebar");
    if (root) {
      var obs = new MutationObserver(function (mutations) {
        if (applying) return;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === "childList" && mutations[i].addedNodes.length) {
            scheduleApply();
            return;
          }
        }
      });
      obs.observe(root, { childList: true, subtree: true });
    }

    var classObs = new MutationObserver(function () {
      scheduleApply();
    });
    classObs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.igId7ApplyFreeShipping = applyAll;
})();
